module.exports = __webpack_public_path__ + "img/user-2.c1a7c533.svg";